<template>
    <div class="sign-form">
        <Form ref="form" class="form" :model="form" :rules="ruleInline">
            <FormItem prop="phone">
                <Input type="text" size="large" ref="phoneInput" @input="removeSpaces('phone')" v-model="form.phone"
                    :placeholder="$t('sign.phone')">
                <div slot="prepend" @click="goLange" class="select-qh-item">
                    <div>+{{ form.area }}</div>
                    <van-icon name="arrow-down" />
                </div>
                </Input>
            </FormItem>
            <FormItem prop="nickname">
                <Input type="text" size="large" v-model="form.nickname" :placeholder="$t('sign.Nickname')" />
            </FormItem>
            <FormItem prop="password">
                <Input type="password" ref="passwordInput" @input="removeSpaces('password')" password size="large"
                    v-model="form.password" :placeholder="$t('sign.password')" />
            </FormItem>
            <FormItem prop="confirmPassword">
                <Input type="password" password ref="confirmPasswordInput" @input="removeSpaces('confirmPassword')"
                    size="large" v-model="form.confirmPassword" :placeholder="$t('sign.confirmPassword')" />
            </FormItem>
            <FormItem prop="invite">
                <Input type="text" ref="inviteInput" @input="removeSpaces('invite')" size="large" v-model="form.invite"
                    :placeholder="$t('sign.recommendationCode')" />
            </FormItem>
            <FormItem prop="isAgree" class="FormItemIsAgree">
                <Checkbox v-model="form.isAgree"><span class="isAgreeTxt">{{ $t('sign.protocol') }}</span></Checkbox>
            </FormItem>
            <FormItem class="signBtn">
                <van-button class="signbtn-con" :loading="loading" :loading-text="$t('loading.loadingSign')"
                    @click.prevent="handleSubmit('form')" type="danger">{{ $t('sign.registerBtn') }}</van-button>
            </FormItem>
            <p class="goLoginmsg">{{ $t('sign.Existing') }}<span class="goLogin" @click="goLogin()">{{
                $t('sign.goLogin') }}</span></p>
        </Form>
    </div>
</template>
<script>
import { Sign } from '@/api'
export default {
    props: ['value', 'Invite'],
    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('sign.rule.password[1]')));
            } else {
                if (this.form.passwdCheck !== '' && value.length >= 6) {
                    // 对第二个密码框单独验证
                    this.$refs.form.validateField('confirmPassword');
                    callback();
                } else {
                    callback(new Error(this.$t('sign.rule.password[2]')));
                }
            }
        };
        const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('sign.rule.password[4]')));
            } else if (value !== this.form.password) {
                callback(new Error(this.$t('sign.rule.password[3]')));
            } else {
                callback();
            }
        };
        const validateisAgree = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('sign.rule.isAgree')));
            } else {
                callback();
            }
        };
        // 邀请码验证
        const validateInviteCode = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t("sign.rule.invite[0]")));
            } else {
                if (!/^\d+$/.test(value)) {
                    callback(new Error(this.$t("sign.rule.invite[1]")));
                } else {
                    callback();
                }
            }
        };
        return {
            loading: false,
            form: {
                phone: '', //电话
                nickname: '', //昵称
                area: '+81', //区号
                password: '', //密码
                invite: '', // 推荐码
                confirmPassword: '', //确认密码
                // code: '', //验证码
                isAgree: false //是否同意协议
            },
            ruleInline: {
                phone: [
                    { required: true, message: this.$t('sign.rule.phone[1]'), trigger: 'blur' },
                    // { pattern: /^1[34578]\d{9}$/, message: this.$t('sign.rule.phone[2]'), trigger: 'blur' }
                ],
                nickname: [
                    { required: true, message: this.$t('sign.rule.nickname'), trigger: 'blur' },
                ],
                invite: [{ validator: validateInviteCode, trigger: "blur" }],
                password: [
                    { validator: validatePass, trigger: 'blur' },
                ],
                confirmPassword: [
                    { validator: validatePassCheck, trigger: 'blur' },
                ],
                isAgree: [
                    { validator: validateisAgree, trigger: 'change' },
                ]
            }
        }
    },
    created() {

    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                this.form.area = newVal
            },
            immediate: true
        },
        Invite: {
            handler(newVal, oldVal) {
                this.form.invite = newVal
            },
            immediate: true
        }
    },
    methods: {
        removeSpaces(field) {
            if (this.form[field] == undefined) {
                return
            }

            if (field == 'phone' || field == "invite") {
                if (/[^\d]/.test(this.form[field])) {
                    let str = this.form[field].replace(/[^\d]/g, '');
                    this.$nextTick(() => {
                        const inputElement = this.$refs[field + 'Input'];
                        inputElement.$emit('input');
                        this.form[field] = str;
                    });
                }
            } else if (this.form[field].includes(' ')) {
                let str = this.form[field].replace(/\s+/g, '');
                this.$nextTick(() => {
                    const inputElement = this.$refs[field + 'Input'];
                    inputElement.$emit('input');
                    this.form[field] = str
                });
            }
        },
        goLange() {
            this.$router.push({
                path: '/language',
            })
        },
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    let data = {
                        nickname: this.form.nickname,
                        phone: '+' + this.form.area + this.form.phone,
                        password: this.form.password,
                        invite: this.form.invite,
                    }
                    this.sign(data)
                }
            })
        },
        // 注册
        sign(form) {
            this.loading = true;
            form.user_from = 'wmt'
            Sign(form).then(res => {
                if (res.code == 1) {
                    this.$Toast.success(res.info);
                    this.goLogin()
                }
                this.loading = false;
            })
        },
        // 切换登录
        goLogin() {
            this.$emit('chengeIsLogin', true)
        }
    }
}
</script>
<style lang="scss" scoped>
.sign-form {
    position: relative;
    width: 100%;
    // height: 580px;
    background-color: #fff;
    margin-top: 30px;
    display: flex;
    padding: 40px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    flex-shrink: 0;
    border-radius: 20px;
    box-shadow: 0px 6px 10px 0px rgba(255, 153, 0, 0.20);
    color: #000;

    .select-qh {
        width: 80px;
    }

    ::v-deep(.ivu-input) {
        padding: 0 20px;
        height: 46px;
    }

    .form {
        width: 100%;

        .select-qh-item {
            width: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        ::v-deep(.ivu-input-group-append) {
            border-radius: 5px;
            background: #F7F7F7;
        }

        ::v-deep(.ivu-input-group-prepend) {
            border-radius: 5px;
            background: #F7F7F7;
            border: none;
        }

        ::v-deep(.ivu-input) {
            border-radius: 5px;
            background: #F7F7F7;
            border: none;
            outline: none;
            box-shadow: none;
        }

        .FormItemBorder {
            span {
                color: #0866FF;
                font-size: 14px;
                padding-right: 10px;
            }

            ::v-deep(.ivu-input) {
                border-right: none;
            }
        }

        .FormItemIsAgree {
            .isAgreeTxt {
                color: #717180;
                font-size: 12px;
            }

            ::v-deep(.ivu-checkbox-inner) {
                margin-right: 5px;
            }
        }

        .signBtn {
            .signbtn-con {
                height: 46px;
                width: 100%;
                border-radius: 10px;
                background: #0866ff;
                box-shadow: 0px 6px 10px 0px rgba(128, 128, 128, 0.50);
                border: none;
            }
        }

        .goLoginmsg {
            text-align: center;
            color: #717180;
            font-size: 12px;

            .goLogin {
                color: #0866FF;
            }
        }
    }
}
</style>